import { APPOINTMENT_MANAGEMENT, BENCHMARKS_SETUP_IDS, SCHEDULING } from "@consts";

export const NAVIGATION_MODES = {
  ASSISTANT: "assistant",
  ACCOUNT: "account",
  ADMIN: "admin"
};

export const DRAWER_WIDTH = 264;
export const COLLAPSED_DRAWER_WIDTH = 64;
export const NAV_ITEM_HEIGHT = 38;
export const COLLAPSED_NAV_ITEM_SIZE = 48;
export const COLLAPSED_NAV_ITEM_BORDER_RADIUS = "2px";
export const NAV_ICON_BOX_SIZE = 24;
export const NAV_ICON_GLYPH_SIZE = 18;
export const COLLAPSED_DIVIDER_WIDTH = 32;
export const NAV_LABEL_MAX_WIDTH = "180px";
export const TOOLTIP_BORDER_RADIUS = "4px";

export const NAVIGATION_LABELS = {
  collapseNavigation: "Collapse navigation",
  expandNavigation: "Expand navigation"
};

export const NAVIGATION_DOM_IDS = {
  sectionRegion: sectionKey => `navigation-section-${sectionKey}`,
  itemChildrenRegion: itemKey => `navigation-item-children-${itemKey}`
};

export const hasOnlyChild = navItem => navItem.children?.length === 1;

// Each report under Skill performance has its own flag and, for Scheduling, its own benchmarks setup, so the
// group and its index route show whichever reports the agent can open.
export const SKILL_PERFORMANCE_PAGES = [
  {
    path: SCHEDULING,
    text: "Scheduling",
    // eslint-disable-next-line no-secrets/no-secrets
    requiredFlag: "enableSchedulingReportDashboard",
    requiredBenchmarksSetup: BENCHMARKS_SETUP_IDS.ACTION_SCHEDULING
  },
  {
    path: APPOINTMENT_MANAGEMENT,
    text: "Appointment management",
    requiredFlag: "appointmentManagementReport"
  }
];

export const isNavChildEnabled = (navChild, flags, benchmarksSetupId) =>
  (!navChild.requiredFlag || Boolean(flags[navChild.requiredFlag])) &&
  (!navChild.requiredBenchmarksSetup || navChild.requiredBenchmarksSetup === benchmarksSetupId);

export const NAVIGATION_TEST_IDS = {
  collapseToggle: "navigation-collapse-toggle",
  sectionToggle: sectionKey => `navigation-section-toggle-${sectionKey}`,
  item: text => `navigation-item-${text}`
};
